import React from 'react';
import { Layout, Row, Col, Typography, Button } from 'antd';
import {
    CheckOutlined,
    ControlOutlined,
    RotateRightOutlined
} from '@ant-design/icons';
import wordCard from '../../assets/lending/word-card5.jpg';
import { ReactComponent as WordIcon } from '../../assets/icon/word.svg';
import { ReactComponent as FlashcardIcon } from '../../assets/icon/flashcard.svg';
import { ReactComponent as QuizIcon } from '../../assets/icon/quiz.svg';
import { useNavigate } from 'react-router-dom';
import useIsMobile from "../../hooks/useIsMobile";





const { Content, Footer } = Layout;
const { Title, Paragraph } = Typography;

const LandingPage = () => {


    const navigate = useNavigate();
    const isMobile = useIsMobile();


    const handleSignIn = () => {
        // Переходим на страницу логина
        navigate('/registration');
    };

    return (
        <Layout
            style={{
                minHeight: '100vh',
                margin: 0,
                padding: isMobile ? '10px' : '0px',
                width: '100%',
            }}
        >
            {/* Hero Section (с двумя колонками) */}
            <Content
                style={{
                    margin: 0,
                    paddingTop: '20px',
                    width: '100%',
                    backgroundColor: '#f7f7f8',
                }}
            >
                <Row justify="center">
                    <Col
                        style={{
                            maxWidth: 1200,
                            width: '100%',
                            paddingTop: '20px',
                            paddingBottom: '20px',
                            paddingLeft: isMobile ? '20px' : '80px', // Адаптивный отступ слева
                            paddingRight: isMobile ? '10px' : '0px',
                            backgroundColor: '#ededf1',
                            borderRadius: '15px', // Закругление углов
                        }}
                    >
                        <Row gutter={24} align="middle">
                            {/* Левая колонка: текст */}
                            <Col xs={24} md={14}>
                                <Title style={{color: '#000000', marginBottom: isMobile ? '3rem' : '4rem'}}>
                                    Advance Your <span style={{color: '#ef6000'}}>Skills</span> and{' '}
                                    <span style={{color: '#ef6000'}}>Knowledge</span> with{' '}
                                    <span style={{color: '#027b83'}}>RETRIEVE</span>
                                </Title>

                                <Paragraph style={{color: '#000000', marginBottom: '2rem', fontSize: '1rem'}}>
                                    Unlock your academic potential through an all-in-one, results-focused platform.
                                </Paragraph>

                                {/* Теги/преимущества */}
                                <div style={{marginBottom: '2rem'}}>
                  <span
                      style={{
                          display: 'inline-block',
                          backgroundColor: '#d8d9df', // тёмно-серый фон
                          color: '#000000',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          marginRight: '8px',
                          marginBottom: isMobile ? '10px' : '0px',
                      }}
                  >
                    Smart Quiz
                  </span>
                                    <span
                                        style={{
                                            display: 'inline-block',
                                            backgroundColor: '#d8d9df', // тёмно-серый фон
                                            color: '#000000',
                                            padding: '4px 8px',
                                            borderRadius: '4px',
                                            marginRight: '8px',
                                        }}
                                    >
                    Memory Flashcards
                  </span>
                                    <span
                                        style={{
                                            display: 'inline-block',
                                            backgroundColor: '#d8d9df', // тёмно-серый фон
                                            color: '#000000',
                                            padding: '4px 8px',
                                            borderRadius: '4px',
                                        }}
                                    >
                    Word Builder
                  </span>
                                </div>

                                {/* Кнопка (CTA) */}
                                <div style={{textAlign: isMobile ? 'center' : 'left'}}>

                                    <Button
                                        type="primary"
                                        size="large"
                                        style={{
                                            marginBottom: '20px',
                                            fontWeight: 'bold',
                                            fontSize: '16px', // Увеличиваем размер шрифта
                                            padding: '12px 24px', // Добавляем отступы внутри кнопки
                                        }}
                                        onClick={handleSignIn}
                                    >
                                        Create account
                                    </Button>
                                    </div>
                            </Col>

                            {/* Правая колонка: изображение */}
                            {!isMobile && (
                                <Col xs={24} md={10} style={{ textAlign: 'center' }}>
                                    <img
                                        src={wordCard}
                                        alt="Word Card"
                                        style={{
                                            height: '460px', // фиксированная высота
                                            width: 'auto', // ширина рассчитывается пропорционально
                                            marginTop: '1rem',
                                            borderRadius: '3px', // Закругление углов
                                        }}
                                    />
                                </Col>
                            )}

                        </Row>
                    </Col>
                </Row>
            </Content>

            {/* NEW BLOCK: All-In-One Solution (с тремя карточками) */}
            <Content
                style={{
                    margin: 0,
                 //   padding: '40px 0',
                    paddingTop: '20px',
                    width: '100%',
                    backgroundColor: '#f7f7f8',
                }}
            >
                <Row justify="center">
                    <Col
                        style={{
                            maxWidth: 1200,
                            width: '100%',
                            paddingTop: '20px',
                            paddingBottom: '20px',
                            paddingLeft: '80px',
                            paddingRight: '80px',
                            backgroundColor: '#ededf1',
                            borderRadius: '15px',
                        }}
                    >
                        {/* Заголовок и описание */}
                        <Row gutter={24} justify="center">
                            <Col span={24}>
                                <Title
                                    style={{
                                        color: '#000000',
                                        marginBottom: '2rem',
                                        textAlign: 'center',
                                    }}
                                >
                                    All-In-One <span style={{ color: '#ef6000' }}>Solution</span>
                                </Title>
                                <Paragraph
                                    style={{
                                        color: '#000000',
                                        marginBottom: '2rem',
                                        fontSize: '1rem',
                                        textAlign: 'center',
                                    }}
                                >
                                    Experience a holistic platform that merges interactive quizzes, efficient flashcards,
                                    and targeted word training—all in one place for unstoppable progress.
                                </Paragraph>
                            </Col>
                        </Row>

                        {/* Три колонки (Quiz, Flashcard, Word) */}
                        <Row gutter={24} justify="center">
                            {/* Quiz */}
                            <Col xs={24} md={8} style={{ textAlign: 'center', marginBottom: '2rem' }}>
                                <QuizIcon
                                    style={{
                                        height: '40px',      // Задаём высоту
                                        width: 'auto',       // Ширина будет пропорциональна высоте
                                        fill: '#ef6000', // Устанавливаем цвет SVG
                                        display: 'inline-block', // Убедитесь, что SVG отображается как блок
                                    }}
                                />
                                <Title level={3} style={{ color: '#000000FF' }}>
                                    Quiz
                                </Title>
                                <Paragraph style={{ color: '#000000' }}>
                                    Dive into dynamic question sets that provide immediate feedback,
                                    helping you identify and fill knowledge gaps.
                                </Paragraph>
                            </Col>

                            {/* Flashcard */}
                            <Col xs={24} md={8} style={{ textAlign: 'center', marginBottom: '2rem' }}>
                                <FlashcardIcon
                                    style={{
                                        height: '40px',      // Задаём высоту
                                        width: 'auto',       // Ширина будет пропорциональна высоте
                                        fill: '#ef6000', // Устанавливаем цвет SVG
                                        display: 'inline-block', // Убедитесь, что SVG отображается как блок
                                    }}
                                />
                                <Title level={3} style={{ color: '#000000FF' }}>
                                    Flashcard
                                </Title>
                                <Paragraph style={{ color: '#000000FF' }}>
                                    Solidify your memory with quick, repetitive reviews and spaced repetition,
                                    ensuring information sticks for the long run.
                                </Paragraph>
                            </Col>

                            {/* Word */}
                            <Col xs={24} md={8} style={{textAlign: 'center', marginBottom: '2rem'}}>

                                <WordIcon
                                    style={{
                                        height: '40px',      // Задаём высоту
                                        width: 'auto',       // Ширина будет пропорциональна высоте
                                        fill: '#ef6000', // Устанавливаем цвет SVG
                                        display: 'inline-block', // Убедитесь, что SVG отображается как блок
                                    }}
                                />


                                <Title level={3} style={{color: '#000000FF'}}>
                                    Word
                                </Title>
                                <Paragraph style={{color: '#000000FF'}}>
                                    Expand your vocabulary through specialized word-building exercises,
                                    turning new terms into active, usable knowledge.
                                </Paragraph>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Content>








            {/* NEW BLOCK: Choose Your Learning Algorithm */}
            <Content
                style={{
            //        margin: '40px 0', // отступ 40px сверху и снизу, чтобы дать пространство между блоками
                 //   padding: '40px 0',
                    paddingTop: '20px',
                    width: '100%',
                    backgroundColor: '#f7f7f8',
                }}
            >
                <Row justify="center">
                    <Col
                        style={{
                            maxWidth: 1200,
                            width: '100%',
                            paddingTop: '20px',
                            paddingBottom: '20px',
                            paddingLeft: '80px',
                            paddingRight: '80px',
                            backgroundColor: '#ededf1',
                            borderRadius: '15px',
                        }}
                    >
                        {/* Заголовок и описание */}
                        <Row gutter={24} justify="center">
                            <Col span={24}>
                                <Title
                                    style={{
                                        color: '#000000FF',
                                        marginBottom: '2rem',
                                        textAlign: 'center',
                                    }}
                                >
                                    Choose Your  <span style={{ color: '#027b83' }}>Learning Algorithm</span>
                                </Title>
                                <Paragraph
                                    style={{
                                        color: '#000000FF',
                                        marginBottom: '2rem',
                                        fontSize: '1rem',
                                        textAlign: 'center',
                                    }}
                                >

                                    {/*<span style={{fontWeight: 'bold'}}>RETRIEVE</span>*/}
                                    RETRIEVE offers flexible and customizable
                                    learning algorithms to match your unique study preferences and goals.


                                </Paragraph>
                            </Col>
                        </Row>

                        {/* Два блока с алгоритмами */}
                        <Row gutter={24} justify="center">
                            {/* Алгоритм: N Correct */}
                            <Col xs={24} md={6} style={{ textAlign: 'center', marginBottom: '2rem' }}>
                                <ControlOutlined
                                    style={{ fontSize: '36px', color: '#ef6000', marginBottom: '1rem' }}
                                />
                                <Title level={3} style={{ color: '#000000FF' }}>
                                    N Correct
                                </Title>
                                <ul style={{ color: '#000000FF', listStyleType: 'none', padding: 0}}>
                                    <li>
                                        Set correct answer thresholds
                                    </li>
                                    <li>
                                        Choose item ranges
                                    </li>
                                    <li>
                                        Define item pools
                                    </li>
                                </ul>
                            </Col>

                            {/* Алгоритм: Five Box */}
                            <Col xs={24} md={6} style={{ textAlign: 'center', marginBottom: '2rem' }}>
                                <RotateRightOutlined
                                    style={{ fontSize: '36px', color: '#ef6000', marginBottom: '1rem' }}
                                />
                                <Title level={3} style={{ color: '#000000FF' }}>
                                    Five Box
                                </Title>
                                <ul style={{ color: '#000000FF', listStyleType: 'none', padding: 0 }}>
                                    <li>
                                        Classic five-box system
                                    </li>
                                    <li>
                                        Automatic word progression
                                    </li>
                                    <li>
                                        Schedule box transitions
                                    </li>
                                </ul>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Content>














            {/* Features Section */}
            <Content
                style={{
                    margin: 0,
                    paddingTop: '20px',
                    paddingBottom: '50px',
                    width: '100%',
                    backgroundColor: '#f7f7f8',
                }}
            >
                <Row justify="center">
                    <Col
                        style={{
                            maxWidth: 1200,
                            width: '100%',
                            padding: '40px 20px',
                            backgroundColor: '#ededf1',
                            borderRadius: '15px',
                        }}
                    >
                        <Row gutter={24} align="top">
                            {/* Left Column: Title */}
                            <Col xs={24} md={8} style={{ textAlign: 'left' }}>
                                <Title
                                    level={2}
                                    style={{
                                        color: '#000000FF',
                                        marginBottom: '1rem',
                                        marginLeft: '20px',
                                    }}
                                >
                                    Discover the Power of <span style={{ color: '#027b83' }}>RETRIEVE</span>
                                </Title>
                            </Col>

                            {/* Middle Column: Plan Title and List */}
                            <Col xs={24} md={8} style={{ textAlign: 'left' }}>
                                <Title
                                    level={3}
                                    style={{
                                        color: '#000000FF',
                                        marginBottom: '1rem',
                                    }}
                                >
                                    <span style={{color: '#ef6000'}}>FREE</span> Basic Plan
                                </Title>
                                <ul style={{color: '#000000FF', listStyleType: 'none', padding: 0 }}>
                                    <li>
                                        <CheckOutlined style={{ color: '#ef6000', marginRight: '8px' }} />
                                        <strong>10 Decks</strong> for Quizzes, Flashcards, and Word Building
                                    </li>
                                    <li>
                                        <CheckOutlined style={{ color: '#ef6000', marginRight: '8px' }} />
                                        <strong>250 Items</strong> in each deck
                                    </li>
                                    <li>
                                        <CheckOutlined style={{ color: '#ef6000', marginRight: '8px' }} />
                                        <strong>Unlimited Time</strong> for testing and practice
                                    </li>
                                    <li>
                                        <CheckOutlined style={{ color: '#ef6000', marginRight: '8px' }} />
                                        All Types of Practice
                                    </li>
                                    <li>
                                        <CheckOutlined style={{ color: '#ef6000', marginRight: '8px' }} />
                                        <strong>25+ Language Presets</strong>
                                    </li>
                                </ul>
                            </Col>

                            {/* Right Column: Sign In Button */}
                            <Col xs={24} md={8} style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <Button
                                    type="primary"
                                    size="large"

                                    style={{
                                        marginTop: '70px',
                                        fontWeight: 'bold',
                                        padding: '12px 24px',
                                    }}
                                    onClick={handleSignIn}
                                >
                                    Create account
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Content>


            {/* Footer Section */}
            <Footer
                style={{
                    margin: 0,
                    padding: 0,
                    width: '100%',
                    backgroundColor: '#212529',
                }}
            >
                <Row justify="center" style={{ padding: '24px 0', color: '#ffffff' }}>
                    <Col style={{ maxWidth: 1200, width: '100%', textAlign: 'center' }}>
                        © 2025 RETRIEVE. All rights reserved.
                    </Col>
                </Row>
            </Footer>
        </Layout>
    );
};

export default LandingPage;
